<template>
   <section class="contactus-section">
     <header class="contactus-head">
       <h1>Contact Us</h1>
       <p>Get In Touch With Us</p>
     </header>
     <div class="contactus-body">
       <div class="describ">
         <address class="address">
           <strong class="h2">Office Address:</strong>
           <p>iMediaMatch ApS Vestergade 39, 1.5000 Odense C</p>
         </address>
         <div class="contact-info">
           <ul class="info">
             <li><a href="mailto:support@planetcricket.com"><i class="ico ico-mail"></i>info@planetcricket.com</a></li>
           </ul>
         </div>
       </div>
       <form @submit="onSubmit" class="contact-form">
         <h2>Get In Touch With Us</h2>
         <div class="form-group">
           <input class="form-control" type="text" v-model="name" name="name" placeholder="Name">
         </div>
         <div class="form-group">
           <input class="form-control" type="email" v-model="email" name="email" placeholder="Email">
         </div>
         <div class="form-group">
           <textarea class="form-control"  v-model="message" name="message" placeholder="Message"></textarea>
         </div>
         <div class="text-right">
           <button class="btn btn-warning" type="submit">Send</button>
         </div>
       </form>
     </div>
   </section>
</template>

<script>
    export default {
        name : 'ContactUs',
        data (){
            return {
                name : '',
                email : '',
                message : ''
            }
        },
        methods : {
            onSubmit(e){
                e.preventDefault()
                // console.log('name',this.name, 'email',this.email,'message',this.message)
            }
        }
    }
</script>
